import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Terms of Service</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">Last updated: January 2025</p>

          <Card className="border-gray-200 dark:border-gray-800">
            <CardContent className="pt-6 space-y-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Terms and Conditions</h2>
                <p className="text-gray-700 dark:text-gray-300">
                  By accessing and using DevTools Hub, you accept and agree to be bound by the terms and provisions of this agreement.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Use of Service</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-2">
                  You are granted a non-exclusive, non-transferable license to use our tools for:
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Personal use</li>
                  <li>Commercial projects</li>
                  <li>Educational purposes</li>
                  <li>Any lawful purpose</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Restrictions</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-2">
                  You agree not to:
                </p>
                <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Use the service for any illegal purpose</li>
                  <li>Attempt to reverse engineer or copy our tools</li>
                  <li>Use automated systems to scrape or download content</li>
                  <li>Interfere with the proper functioning of the service</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Disclaimer</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  The service is provided "as is" without any warranties, expressed or implied. We do not guarantee that 
                  the service will be uninterrupted or error-free. Use at your own risk.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Limitation of Liability</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  DevTools Hub shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
                  resulting from your use of or inability to use the service.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Changes to Terms</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  We reserve the right to modify these terms at any time. Continued use of the service after changes 
                  constitutes acceptance of the new terms.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  For questions about these terms, please contact us at legal@devtoolshub.com
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;